export default "__VITE_ASSET__BPlE1fJm__"